module.exports = __webpack_public_path__ + "static/media/MM_Head.60b181df.png";